import type { ReactNode } from "react";

export type AdminScope = "account" | "site";

const SCOPE_COPY: Record<AdminScope, string> = {
  account: "Account-wide",
  site: "Per site",
};

export function AdminSectionHead({
  title,
  scope,
  hint,
}: {
  title: string;
  scope?: AdminScope;
  hint?: ReactNode;
}) {
  return (
    <div className="admin__section-head">
      <div className="admin__section-title-row">
        <h2 className="admin__h">{title}</h2>
        {scope !== undefined ? (
          <span className={`admin__scope admin__scope--${scope}`}>{SCOPE_COPY[scope]}</span>
        ) : null}
      </div>
      {hint !== undefined ? <p className="admin__scope-hint">{hint}</p> : null}
    </div>
  );
}
